import 'css-chunksrc/client/pages/searchPage/loader/element/status/styles.scss';export default {
  "status": "_status_1y3ik_1",
  "square": "_square_1y3ik_9",
  "paragraph": "_paragraph_1y3ik_18"
};